export default __webpack_public_path__ + "static/media/gift-5.a448e3d2.svg";